import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { RequestsService } from '../../Services/requests.service';
import { Router } from '@angular/router';
import { UserService } from '../../Services/userservice.service';

import { MatSnackBar } from '@angular/material/snack-bar';

import Swal from 'sweetalert2';


@Component({
  selector: 'app-listusers',
  templateUrl: './listusers.component.html',
  styleUrls: ['./listusers.component.scss']
})
export class ListusersComponent implements OnInit {
  private paginator: MatPaginator;
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  isLoading: boolean = false;
  displayedColumns: string[] = ['email','name', 'rol', 'editar', 'eliminar'];
  public formobjects;

  lista_users:any = []

  constructor(public requests: RequestsService, private router: Router, private userService: UserService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    console.log("aqui ");
    this.getData();
    this.onPropagar();
    this.userService.is_super();

  }

  getData() {
    const email = localStorage.getItem('email');
    this.requests.getAllUsers().subscribe(
      res => {
        if (res) {
          this.lista_users = res['data']
          console.log('listausers',this.lista_users);
          this.lista_users = this.lista_users.filter((user)=> user.estado == 1);
          console.log("email ", this.lista_users);
          this.lista_users = this.lista_users.filter((user)=> user.email != email);
          console.log("email ", this.lista_users);
          this.formobjects = new MatTableDataSource(this.lista_users);
          console.log("formeted ", this.formobjects);
          this.formobjects.paginator = this.paginator;
          this.paginator._intl.itemsPerPageLabel = 'Usuarios por página';
          this.paginator._intl.lastPageLabel = 'Última página';
          this.paginator._intl.nextPageLabel = 'Página siguiente';
          this.paginator._intl.firstPageLabel = 'Primera página';
          this.paginator._intl.previousPageLabel = 'Página anterior';

          this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            const start = page * pageSize + 1;
            const end = (page + 1) * pageSize;
            return `${start} - ${end} de ${this.lista_users.length}`;
          };

          this.isLoading = true;
         // console.log(this.lista_users[0].id);
          
        }

      },
      err => {
        console.log(err);
        if (err.status == 401) {
          this._snackBar.open('Lo sentimos, la sesión ha expirado', '', {
              duration: 5000,
              horizontalPosition: 'left',
              verticalPosition: 'bottom'
          })
          this.router.navigate(['login']);
          return
        }


        return err;

      }

    );
  }

  filtrar(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.formobjects.filter = filtro.trim().toLowerCase();
  }

  setDataSourceAttributes() {
    if (this.paginator) {
      try {
        this.formobjects.paginator = this.paginator;
      } catch (error) {
        //console.log('Error controlado en paginator');
        //console.log(error);
      }
    }
  }

  onPropagar(){
    this.userService.emitChange("Lista de Usuarios")
  }



  editUser(user:any){
    this.router.navigate([`editUser/${user?.id}`]);
  }


  async deleteUser(user:any){
    
    const { value: text } = await Swal.fire({
      icon: 'warning',
      title: `¿Está seguro de querer eliminar al usuario ${user.email}?`,
      input: 'text',
      inputPlaceholder: 'Escriba eliminar para confirmar...',
      inputAttributes: {
        'aria-label': 'Type your message here'
      },
      showCancelButton: true,
      confirmButtonColor: '#e62e1b',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    })
    
    if (text === 'eliminar') {
      //console.log('Eliminar usuario');

      const data = {
        id: user.id
      }

      this.userService.deleteUser(data).subscribe(
        (res:any)=>{

          this.getData();
          
          Swal.fire(
            'Eliminación de usuario',
            `Usuario ${user.email} eliminado correctamente`,
            'success'
          )


        },
        (err:any)=>{
          if(err.status == 401){
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Lo sentimos, la sesión ha expirado',
            })
            this.router.navigate(['login']);
            return
          }

        }
      )
    
      
    }
    
  }


}
